import React from 'react';
import { AlertTriangle, ArrowLeft, RefreshCw } from 'lucide-react';

/**
 * Ловит падение одной страницы, чтобы оно не роняло всё приложение.
 *
 * Раньше любая ошибка рендера (например, статья базы знаний с таблицей —
 * «Cannot set properties of undefined (setting 'inTable')») давала белый экран
 * без меню и без кнопки «назад» (аудит UI 25.09). Теперь падает только
 * содержимое: меню слева живое, на месте страницы — объяснение и две кнопки.
 *
 * Стоит в Layout вокруг children; resetKey = адрес: переход по меню на другую
 * страницу сбрасывает ошибку сам.
 */
export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidUpdate(prevProps) {
    if (this.state.error && prevProps.resetKey !== this.props.resetKey) {
      this.setState({ error: null });
    }
  }

  componentDidCatch(error, info) {
    // В консоль — для разбора; наружу ничего не шлём
    console.error('Ошибка на странице:', error, info?.componentStack);
  }

  render() {
    const { error } = this.state;
    if (!error) return this.props.children;
    const message = String(error?.message || error || '').slice(0, 300);
    return (
      <div className="page-crash" role="alert">
        <AlertTriangle size={32} className="page-crash__icon" />
        <h2 className="page-crash__title">Что-то пошло не так на этой странице</h2>
        <p className="page-crash__text">
          Остальные разделы работают — их можно открыть в меню слева.
          Если ошибка повторяется, сообщите руководителю, что делали перед ней.
        </p>
        <div className="page-crash__actions">
          <button type="button" className="btn btn-outline" onClick={() => window.history.back()}>
            <ArrowLeft size={16} /> Назад
          </button>
          <button type="button" className="btn btn-primary" onClick={() => window.location.reload()}>
            <RefreshCw size={16} /> Обновить
          </button>
        </div>
        {message && <div className="page-crash__detail">{message}</div>}
      </div>
    );
  }
}
